import React, { useEffect, useCallback, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { logout } from "../../slices/authSlice";
import { useSelector, useDispatch } from "react-redux";
import useOutsideClick from "../../hooks/useOutsideClick";
import HelpSection from "../../views/help/HelpSection";
import PropTypes from "prop-types";
import { getNavItems } from "../../utils/helpers";

function Sidebar({ open, closeSidebar, toggleRef }) {
    const { user, returnUrl } = useSelector((state) => state.auth);
    const { config } = useSelector((state) => state.app);
    const sidebarRef = React.useRef(null);
    const sidebarOutsideClick = useOutsideClick(sidebarRef, toggleRef);
    const [openHelp, setOpenHelp] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const url = location.pathname;

    const toggleHelp = () => {
        setOpenHelp(true);
        closeSidebar();
    };

    const closeHelp = useCallback(() => {
        setOpenHelp(false);
    }, []);

    const handleNavigation = (path) => {
        navigate(path);
        closeSidebar();
    };

    const handleLogout = () => {
        dispatch(logout());
        closeSidebar();
    };

    useEffect(() => {
        if (sidebarOutsideClick === true) closeSidebar();
    }, [sidebarOutsideClick, closeSidebar]);

    useEffect(() => {
        if (open) {
            sidebarRef.current?.focus();
        }
    }, [open]);

    // Get navigation items
    const navItems = getNavItems(user, config, returnUrl);

    return (
        <>
            <div
                ref={sidebarRef}
                style={{
                    visibility: open ? "visible" : "hidden",
                    position: open ? "relative" : "absolute",
                    zIndex: open ? 2000000003 : -1,
                }}
            >
                <div
                    className="d-flex flex-column flex-shrink-0 sidebar"
                    style={{
                        transform: open ? "translateX(0%)" : "translateX(-100%)",
                        boxShadow: open ? "4px 0 16px rgba(0, 0, 0, 0.25)" : "none",
                        // height: '100vh',
                        // overflowY: 'auto',
                    }}
                >
                    <div className="sidebar-spacer"></div>
                    <ul className="nav nav-pills nav-flush flex-column ">
                        {navItems.map((item) => item.condition && (
                            <li
                                key={item.id}
                                className={
                                    (url.includes(item.path) ? "bg-target " : "") +
                                    "sidebar-text"
                                }
                                data-testid={item.id}
                                tabIndex={open ? "0" : "-1"}
                                onClick={() => {
                                    if (item.path) {
                                        handleNavigation(item.path);
                                    } else if (item.onClick) {
                                        item.onClick();
                                        closeSidebar();
                                    }
                                }}
                            >
                                {item.label}
                            </li>
                        ))}
                        <li
                            className="sidebar-text"
                            tabIndex={open ? "0" : "-1"}
                            onClick={toggleHelp}
                        >
                            Help
                        </li>
                        <li className="d-flex sidebar-text" tabIndex={open ? "0" : "-1"}>
                            <i className="fa-solid fa-circle-user icon"></i>
                            <div onClick={handleLogout}>
                                Sign out | {user?.userName}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            {openHelp && (
                <HelpSection showModal={openHelp} closeHelp={closeHelp} />
            )}
        </>
    );
}

Sidebar.propTypes = {
    open: PropTypes.bool.isRequired,
    closeSidebar: PropTypes.func.isRequired,
    toggleRef: PropTypes.shape({ current: PropTypes.any })
}


export default Sidebar;